// extracted by mini-css-extract-plugin
module.exports = {"root":"Stepper_root__TTyfi","text":"Stepper_text__Zf1Up","btn":"Stepper_btn__PEzYD","disabled":"Stepper_disabled__JDMGW"};